__webpack_require__.p = "https://assets-01.periodica.press/11686e6-23150852888/";